import axios from 'axios'
export const getDataTable = (queryParms) => axios.get(`/meilv/trade/ticket/merchant/api/data/detail/v1`, {
    params: queryParms
})

export const getReserveData = (queryParms) => axios.get(`/meilv/trade/ticket/merchant/api/data/reserve_count/v1`)

export const getHistoryData = (queryParms) => axios.get(`/meilv/trade/ticket/merchant/api/data/history/v1`, {
    params: queryParms
})





// WEBPACK FOOTER //
// ./src/api/dataCenter.js